<template>
    <svg :class="classes" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         width="509.635px" height="477.619px" viewBox="2.365 16 509.635 477.619" enable-background="new 2.365 16 509.635 477.619"
         xml:space="preserve">
        <g>
            <polygon fill="#010101" points="489.979,465.835 489.979,54.358 432.391,16 226.184,113.837 226.184,182.886 111.123,221.244
                111.123,271.385 25.442,295.283 25.442,464.059 2.365,464.059 2.365,492.049 25.442,492.049 25.442,492.179 51.362,492.049
                51.67,313.871 195.838,278.818 195.002,491.638 215.597,491.778 215.597,492.049 264.154,492.049 264.154,464.059 249.336,464.059
                249.336,295.335 214.208,242.597 137.981,263.885 137.981,242.352 287.592,191.503 287.592,491.664 394.045,491.664
                394.045,463.88 373.902,463.88 373.902,186.719 315.426,150.265 254.031,171.386 254.983,133.016 404.594,62.024 404.594,493.619
                512,493.619 512,465.835 	"/>
            <polygon fill="#010101" points="309.87,279.836 204.495,279.836 204.495,248.526 309.87,229.785 	"/>
            <polygon fill="#010101" points="309.87,261.105 204.495,279.836 204.495,248.513 309.87,229.785 	"/>
            <polygon fill="#010101" points="309.87,261.105 204.495,279.836 204.495,248.539 309.87,229.785 	"/>
            <polygon fill="#010101" points="309.87,261.105 204.495,279.836 204.495,248.526 309.87,229.785 	"/>
        </g>
    </svg>
</template>

<script>
    export default {
        name: 'MallsSvg',
        props: ['classes'],
    }
</script>

<style scoped lang="scss">

</style>
